export default "__VITE_ASSET__32b2740f__"